<clr-main-container>
	<div class="content-container">
		<div class="content-area mac-content-area">
			<div class="XCcontainer">
				<div class="XCcard card mt-0">
					<div class="card-block text-center">
						<div class="clr-row">
							<div class="clr-col-md-6 clr-col-sm-12 pt-2 pb-2">
								<img src="assets/img/headerlogo.png" height="100%" alt="myASI" />
							</div>
							<div class="clr-col-md-6 clr-col-sm-12">
								<h1 class="XCheadline mb-2">
									Ausloggen
									<cds-icon shape="logout" class="XCicon"></cds-icon>
								</h1>
								<svg-frontends-loading class="XCspinner" [isInline]="false" [absolute]="false"></svg-frontends-loading>
								<h3 class="mt-1 mb-2">Logout wird durchgeführt. Sie werden gleich zur Login Seite weitergeleitet.</h3>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</clr-main-container>
